import { PayCodeMeasureUnit } from "@/data/pay-codes";

import { formatLoggedTime } from "./formatLoggedTime";
import { TimeReportLoggedTime } from "./TimeReportLoggedTime";

export const reportedTimeToLoggedTime = (
  reportedTime: number,
  measureUnit: PayCodeMeasureUnit,
): TimeReportLoggedTime => {
  return {
    formattedAmount: formatLoggedTime(reportedTime, measureUnit),
    measureUnit,
    reportedTime,
    isEmpty: reportedTime <= 0,
  };
};
